import React from 'react';

import { GeneralLayout } from '@hero/layouts';

export default function Layout({ children, steps, activeStep }) {
  return (
    <GeneralLayout steps={steps} activeStep={activeStep}>
      {children}
    </GeneralLayout>
  );
}
